import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUpload = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M12.71 7.29a1 1 0 00-.32-.21A1 1 0 0012 7h-.1a.82.82 0 00-.46.17 1 1 0 00-.13.09l-3 2.86a1 1 0 001.38 1.45L11 10.34V16a1 1 0 002 0v-5.59l1.29 1.3a1 1 0 001.42 0 1 1 0 000-1.42l-3-3z" }), /* @__PURE__ */ _jsx("path", { d: "M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10A10 10 0 0012 2zm0 18a8 8 0 110-16 8 8 0 010 16z" })]
		})
	})
});
export { SvgUpload as ReactComponent };
